export default "__VITE_ASSET__CDvbaDxx__"